import { render, staticRenderFns } from "./CompositionOptionsSection.vue?vue&type=template&id=1aae96ac&"
import script from "./CompositionOptionsSection.vue?vue&type=script&lang=js&"
export * from "./CompositionOptionsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports